module.exports = __webpack_public_path__ + "static/rezydencja-swierkowa-3dccf275f37775d1f3c5a93b503b1579.png";